export function createIndicadoresClient() {
  const worker = new Worker(new URL("./indicadores.worker.js", import.meta.url));
  const pending = new Map();
  let sequence = 0;
  let failure = "";
  worker.onmessage = ({ data }) => {
    const task = pending.get(data.id);
    if (!task) return;
    pending.delete(data.id);
    if (data.error) task.reject(new Error(data.error));
    else task.resolve(data.result);
  };
  const rejectAll = (message) => {
    pending.forEach((task) => task.reject(new Error(message)));
    pending.clear();
  };
  worker.onerror = () => {
    failure = "No se pudo iniciar el procesamiento. Recarga la página para reintentar.";
    rejectAll(failure);
  };
  return {
    request(action, payload) {
      if (failure) return Promise.reject(new Error(failure));
      return new Promise((resolve, reject) => {
        const id = ++sequence;
        pending.set(id, { resolve, reject });
        try {
          worker.postMessage({ id, action, payload });
        } catch (error) {
          pending.delete(id);
          reject(error);
        }
      });
    },
    dispose() {
      worker.terminate();
      rejectAll("Procesamiento cancelado.");
    },
  };
}
